import { IContainer } from '../../interface/container';
import { bindAPISession, unbindAPISession } from '../interface/bind';
import sessionInst from '../impl/session.bind';

function bind(container: IContainer) {
    bindAPISession(sessionInst(container), container);
}

function unbind(container: IContainer) {
    unbindAPISession(container);
}

const module = {
    bind,
    unbind,
};

export default module;
